import { AdjustConfigGlobal, AdjustConfigGlobalDefault } from "./adjust-config.types";
import {
    createItemListColumnPreferences,
    ItemListColumnPreferences,
} from "../../items/model/item-list.types";


export interface UserConfigInputs {
    adjust_config: AdjustConfigGlobal;
    // 분리된 설정
    adjust_no_exposed: {
        use_global: boolean;
        is_enabled: boolean;
    };
    skip_low_coupon: {
        use_global: boolean;
        is_enabled: boolean;
        value: number;
        value_type: 'percent' | 'amount';
    };
    adjust_max_step: {
        use_global: boolean;
        is_enabled: boolean;
        value: number;
        value_type: 'percent' | 'amount';
    };
    reset_max_step: {
        use_global: boolean;
        is_enabled: boolean;
        value: number;
        value_type: 'percent' | 'amount';
    };
    reset_on_ll: {
        use_global: boolean;
        is_enabled: boolean;
    };
    reset_on_ll_countime: {
        use_global: boolean;
        is_enabled: boolean;
        value: number;
        value_type: 'percent' | 'amount';
    };
    should_recover_price_on_active_schedule: boolean;
    item_reprocess_wait_minutes: number;
    item_list_column_config: ItemListColumnPreferences;
}

export function normalizeReprocessWaitSettings(data: {
    item_reprocess_wait_minutes?: number | null;
    min_item_reprocess_wait_minutes?: number | null;
}) {
    const minimum = data.min_item_reprocess_wait_minutes ?? 3;
    return {
        minimum,
        value: Math.max(minimum, data.item_reprocess_wait_minutes ?? minimum),
    };
}

export const UserConfigInputsDefault: UserConfigInputs = {
    adjust_config: AdjustConfigGlobalDefault,
    adjust_no_exposed: {
        use_global: true,
        is_enabled: false,
    },
    skip_low_coupon: {
        use_global: true,
        is_enabled: false,
        value: 1,
        value_type: 'percent',
    },
    adjust_max_step: {
        use_global: true,
        is_enabled: false,
        value: 0,
        value_type: 'percent',
    },
    reset_max_step: {
        use_global: true,
        is_enabled: false,
        value: 0,
        value_type: 'percent',
    },
    reset_on_ll: {
        use_global: true,
        is_enabled: false,
    },
    reset_on_ll_countime: {
        use_global: true,
        is_enabled: false,
        value: 5,
        value_type: 'percent',
    },
    should_recover_price_on_active_schedule: true,
    item_reprocess_wait_minutes: 3,
    item_list_column_config: createItemListColumnPreferences()
};
